import { useCandidatesAPI } from '@innowise-group/core';
import { Modal, modalHoc, ModalProps } from '@innowise-group/mui-kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './candidate-import-modal.styles';

export interface CandidateImportModalProps {
  onImportCompleted: () => void;
}
const modalButtonStyle = { fontSize: '0.8rem' };

const CandidateImportModal: FC<ModalProps & CandidateImportModalProps> = ({ close, onImportCompleted }) => {
  const { t } = useTranslation();
  const { importCandidates, prepareCandidates, isImportLoading } = useCandidatesAPI();
  const importCallbacks = { onStarted: close, onCompleted: onImportCompleted };

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={isImportLoading ? null : close}>
        <Styled.Header>{t('pages.candidates.import.modalTitle')}</Styled.Header>
      </Modal.Header>
      <Styled.Spacer />
      <Modal.Actions
        noVerticalPadding={true}
        position="full"
        actions={[
          {
            title: t('pages.candidates.import.import'),
            onClick: () => importCandidates(importCallbacks),
            type: 'button',
            highlighted: true,
            disabled: isImportLoading,
            style: modalButtonStyle,
          },
          {
            title: t('pages.candidates.import.updateFile'),
            onClick: () => prepareCandidates(importCallbacks),
            type: 'button',
            disabled: isImportLoading,
            style: modalButtonStyle,
          },
        ]}
      />
    </Modal.Container>
  );
};

export default modalHoc(CandidateImportModal, 'candidate-import-modal');
